import * as React from 'react';
import { connect } from 'react-redux';

import { FocusPoint, FocusPointsContainer } from '../../../Shared/index';
import * as questionActions from '../../actions/questions';

interface StateProps {
  focusPoints: { [key: string]: FocusPoint };
}

interface OwnProps {
  match: {
    params: {
      questionID: string;
    };
  };
}

type Props = StateProps & OwnProps & { dispatch: any };

const GrammarFocusPointsContainer: React.FC<Props> = ({ focusPoints, match, dispatch }) => {
  const { questionID } = match.params;
  const baseUrl = `/grammar/#/admin/questions/${questionID}/focus-points`;

  const handleUpdateFocusPoints = (questionID: string, focusPoints: { [key: string]: FocusPoint }, callback?: () => void) => {
    dispatch(questionActions.submitBatchEditedFocusPoint(questionID, focusPoints, callback));
  };

  const handleDeleteFocusPoint = (questionID: string, focusPointID: string) => {
    dispatch(questionActions.deleteFocusPoint(questionID, focusPointID));
  };

  const handleSubmitEditedFocusPoint = (questionID: string, data: FocusPoint, key: string) => {
    dispatch(questionActions.submitEditedFocusPoint(questionID, data, key));
  };

  return (
    <FocusPointsContainer
      baseUrl={baseUrl}
      focusPoints={focusPoints}
      onDeleteFocusPoint={handleDeleteFocusPoint}
      onSubmitEditedFocusPoint={handleSubmitEditedFocusPoint}
      onUpdateFocusPoints={handleUpdateFocusPoints}
      questionID={questionID}
    />
  );
};

function select(state: any, ownProps: OwnProps): StateProps {
  const { questionID } = ownProps.match.params;
  const question = state.questions.data[questionID];

  return {
    focusPoints: question?.focusPoints || {},
  };
}

export default connect(select)(GrammarFocusPointsContainer);
